import * as Sentry from '@sentry/vue'
import { useLabelStore } from '@/stores/label'

export default defineNuxtPlugin((nuxtApp) => {
    if (import.meta.dev) return

    const labelStore = useLabelStore()
    const { SENTRY_DSN } = useRuntimeConfig().public

    Sentry.init({
        app: nuxtApp.vueApp,
        dsn: SENTRY_DSN,
        beforeSend(event) {
            event.extra = { ...event.extra, senseDataUrl: labelStore.senseDataUrl }
            return event
        }
    })
})
